import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header/Header';
import AuthContext from '../../context/AuthContext';
import './AuthPage.css';
import ForgotPassword from '../ForgetPassword/Forgetpassword';

import userAPI from '../../context/Api';


const REGISTRATION_ENABLED = false;

const AuthPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [isAdminLogin, setIsAdminLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isForgotPassword, setIsForgotPassword] = useState(false);

  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
  
    try {
      const payload = {
        email,
        password,
        isAdminLogin,
      };
  
      const response = await userAPI.login(payload);
      const { token, isAdmin, redirect } = response.data;
  
      // Store token and admin status
      localStorage.setItem('token', token);
      localStorage.setItem('isAdmin', isAdmin);
      login(token, isAdmin);
  
      // Navigate to the path returned by the API
      navigate(redirect);
      
      // Clear form fields
      setUsername('');
      setEmail('');
      setPassword('');
      setConfirmPassword('');
    } catch (error) {
      setError(error.response?.data?.error || 'Authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="auth-page">
      <Header />
      <div className="container">
        <div className="auth-container">
          {isForgotPassword ? (
          <ForgotPassword onBack={() => setIsForgotPassword(false)} />
            ) : (
            <>
              <h2 className="text-center mb-4">{isLogin ? 'Login' : 'Register'}</h2>
              <form onSubmit={handleSubmit}>
                {error && <div className="alert alert-danger">{error}</div>}

                {!isLogin && REGISTRATION_ENABLED && (
                  <div className="mb-3">
                    <label htmlFor="username" className="form-label">Username</label>
                    <input
                      type="text"
                      className="form-control"
                      id="username"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </div>
                )}

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                {!isLogin && REGISTRATION_ENABLED && (
                  <div className="mb-3">
                    <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                    />
                  </div>
                )}

                {isLogin && (
                  <>
                    <div className="mb-3 form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="adminLogin"
                        checked={isAdminLogin}
                        onChange={() => setIsAdminLogin(!isAdminLogin)}
                      />
                      <label className="form-check-label" htmlFor="adminLogin">
                        Login as Admin
                      </label>
                    </div>

                    <div className="mb-3">
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={() => setIsForgotPassword(true)}
                      >
                        Forgot Password for Admin?
                      </button>
                    </div>
                  </>
                )}

                <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                  {loading ? 'Processing...' : isLogin ? 'Login' : 'Register'}
                </button>
              </form>

              {REGISTRATION_ENABLED && (
                <div className="text-center mt-3">
                  <button className="btn btn-link" onClick={() => setIsLogin(!isLogin)}>
                    {isLogin ? "Don't have an account? Register" : "Already have an account? Login"}
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AuthPage;

// Next step? I can build out the ForgotPassword component or refine the API calls! Let me know! 🚀